/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Input, message, Row, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import useLoading from "@/hooks/useLoading.js";
import useUser from "@/store/useUser.js";
import investServices from "@/services/apiServices/investServices";
import { CloseCircleOutlined } from "@ant-design/icons";

const StockFinance = () => {
  const [userSetting, setUserSetting] = useState({
    spreadsheet_url: "",
  });
  const [pcStock, setPcStock] = useState("");
  const [financialSheetData, setFinancialSheetData] = useState("");
  const [timeFrame, setTimeFrame] = useState("");

  const [stockList, setStockList] = useState([]);
  const timeList = [
    { value: "", label: "Select Time Frame" },
    { value: "quarterly", label: "Quarterly" },
    { value: "annual", label: "Annual" },
  ];

  const [customStock, setCustomStock] = useState("");

  const { data: userData } = useUser();
  const { executeAction: getStockDetails, loading: stockDetailsLoader } =
    useLoading(async () => {
      const stockData = await investServices.getAllStockList();
      if (stockData?.data?.data) {
        let dataArr = [
          {
            value: "",
            label: "Select Stock",
          },
        ];

        stockData?.data?.data?.map((item) => {
          dataArr.push({
            value: item?.stock,
            label: item?.stock,
            ...item,
          });
        });
        dataArr.push({
          value: "custom",
          label: "Type your Stock",
        });

        setStockList(dataArr);
      }
    });

  const { executeAction: getStockFinancial, loading: stockFinancialLoader } =
    useLoading(async () => {
      try {
        const params = `time_frame=${timeFrame}&ticker=${
          pcStock == "custom" ? customStock : pcStock
        }&spreadsheet_url=${userSetting.spreadsheet_url}`;
        const stockData = await investServices.getStockFinancial(params);
        if (stockData?.data?.success == true) {
          message.success(stockData?.data?.message || "Submit Successful.");
          setFinancialSheetData(stockData.data.spreadsheet_url);
        } else {
          message.error(
            stockData?.data?.message ||
              "Something went wrong. Please try again in some time.",
          );
        }
      } catch (e) {
        message.error(
          typeof e?.response?.data?.message === typeof String()
            ? e?.response?.data?.message
            : "Something went wrong. Please try again in some time.",
        );
      }
    });

  useEffect(() => {
    getStockDetails();
  }, []);

  useEffect(() => {
    if (userData?.data?.settings) {
      setUserSetting({
        ...userData?.data?.settings,
      });
    }
  }, [userData]);

  const LinkChildView = () => (
    <div className="mt-[20px]">
      <strong>Spreadsheet Link : </strong>{" "}
      <a target="_blank" href={financialSheetData} rel="noreferrer">
        {financialSheetData}
      </a>
    </div>
  );

  return (
    <>
      <Row className="flex-col pl-4 w-[500px] ">
        <Row className="items-center mt-[20px] justify-between">
          <Typography.Text className="text-[#696969]">
            <span className="text-red-700">*</span>Google Spreadsheet URL
          </Typography.Text>
          <Input
            placeholder="https://docs.google.com/spreadsheets/"
            className="w-[256px]"
            value={userSetting.spreadsheet_url}
            onChange={(e) =>
              setUserSetting({
                ...userSetting,
                spreadsheet_url: e.target.value,
              })
            }
          />
        </Row>
        <Row className="items-center mt-[20px] justify-between">
          <Typography.Text className="text-[#696969]">
            <span className="text-red-700">*</span>Stock Symbol
          </Typography.Text>

          {pcStock != "custom" ? (
            <Select
              value={pcStock}
              placeholder={"Select Stock"}
              onChange={setPcStock}
              className="w-[256px]"
              options={stockList}
            />
          ) : (
            <Input
              placeholder="Stock Name"
              addonAfter={
                <CloseCircleOutlined
                  onClick={() => {
                    setCustomStock("");
                    setPcStock("");
                  }}
                />
              }
              className="w-[256px]"
              value={customStock}
              onChange={(e) => setCustomStock(e.target.value)}
            />
          )}
        </Row>
        <Row className="items-center mt-[20px] justify-between">
          <Typography.Text className="text-[#696969]">
            <span className="text-red-700">*</span>Time Frame
          </Typography.Text>

          <Select
            value={timeFrame}
            placeholder={"Select Stock"}
            onChange={setTimeFrame}
            className="w-[256px]"
            options={timeList}
          />
        </Row>
        <Row className="items-center mt-[20px]">
          <Button
            type="primary"
            disabled={!userSetting?.spreadsheet_url || !timeFrame || !pcStock}
            className="mr-4 bg-primaryDark"
            onClick={getStockFinancial}
            loading={stockDetailsLoader || stockFinancialLoader}
          >
            Get Data
          </Button>
        </Row>
        {financialSheetData && <LinkChildView />}
      </Row>
    </>
  );
};

export default StockFinance;
